import { EMPTY_LIST, EMPTY_STRING } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'
import { toUserSelectItems } from '../../../User'

import {
  REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_IS_PROVIDERS_INVITATION,
  REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS,
  REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS_COMMENT,
  REQUEST_PROFILE_WIDGET_PROVIDERS_RECOMMENDATION_TYPE,
} from './RequestProfileWidgetProviders.constants'

export function getRequestProfileWidgetProvidersPermissions(
  requestPermissions
) {
  return {
    canEditContractors: Boolean(requestPermissions?.can_edit_contractors),
    canViewContractors: Boolean(requestPermissions?.can_view_contractors),
    canViewRecommendedContractors: Boolean(
      requestPermissions?.can_view_recommended_contractors
    ),
  }
}

export function getRequestProfileWidgetProvidersVisibility({
  recommendedProviders,
  requestPermissions,
}) {
  const { canViewContractors, canViewRecommendedContractors } =
    getRequestProfileWidgetProvidersPermissions(requestPermissions)

  const showSelectedProviders = canViewContractors

  const showRecommendedProviders =
    canViewRecommendedContractors && recommendedProviders.length > 0

  return {
    hasContent: showSelectedProviders || showRecommendedProviders,
    showRecommendedProviders,
    showSelectedProviders,
  }
}

export function getPreparedRequestProfileWidgetRecommendedContractorsData(
  data
) {
  return data?.results?.objects || EMPTY_LIST
}

export function getRequestProfileWidgetProvidersInitialValues(providers) {
  return {
    [REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_IS_PROVIDERS_INVITATION]: false,
    [REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS]:
      toUserSelectItems(providers),
    [REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS_COMMENT]:
      EMPTY_STRING,
  }
}

export function getRequestProfileWidgetProvidersPayload(values) {
  const selectedProviders =
    values[REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS]

  const contractorsPayload = {
    contractor_ids: getItemsIds(selectedProviders, 'value'),
  }

  if (
    values[REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_IS_PROVIDERS_INVITATION]
  ) {
    contractorsPayload.comment =
      values[REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS_COMMENT] ??
      null
  }

  return { contractors: contractorsPayload }
}

export function getRequestProfileWidgetProvidersRecommendationTooltipKey(
  filters
) {
  const hasBuilding = filters?.includes(
    REQUEST_PROFILE_WIDGET_PROVIDERS_RECOMMENDATION_TYPE.building
  )
  const hasCategory = filters?.includes(
    REQUEST_PROFILE_WIDGET_PROVIDERS_RECOMMENDATION_TYPE.category
  )

  if (hasBuilding && !hasCategory) {
    return 'RequestProfile.ProvidersRecommendedProvidersByBuildingTooltipKey'
  }

  if (hasCategory && !hasBuilding) {
    return 'RequestProfile.ProvidersRecommendedProvidersByCategoryTooltipKey'
  }

  return 'RequestProfile.ProvidersRecommendedProvidersByBuildingAndCategoryTooltipKey'
}
